export default __webpack_public_path__ + "static/media/account.3c5658a5.svg";